import React, { Component } from 'react';
import PlugwrapThickness from '../../components/PlugwrapThickness';
import { Modal } from 'antd';
import './TowItemPlugwrap.css';

class TowItemPlugwrap extends Component {

    constructor(props) {
        super(props);
        this.state = {
            plugwrapThicknessVal: 0.042,
            visibleplugwrap: false
        };

        this.updatePlugwrapValue = this.updatePlugwrapValue.bind(this);
    }

    handlePlugwrapCancel = () => {
        this.setState({
            visibleplugwrap: false
        });
    }

    showPlugwrapModal = () => {
        this.setState({
            visibleplugwrap: true
        });
    }

    updatePlugwrapValue(data) {
        this.setState({
            plugwrapThicknessVal: data
        });
    }

    render() {
        return (
            <div className="plugwrap container-fluid">
                <h2 className="plugwrap__title">Plugwrap</h2>
                <div className="plugwrap__form">
                    <label>PW Thickness(mm)</label>
                    <input
                        type="number"
                        value={this.state.plugwrapThicknessVal}
                    />
                </div>
                <button
                    value="Plugwrap"
                    type="button"
                    className="btn btn-primary"
                    onClick={this.showPlugwrapModal}>PLUGWRAP</button>
                <Modal
                    visible={this.state.visibleplugwrap}
                    footer={null}
                    width="60%"
                    centered
                    style={{ top: 20 }}
                    onCancel={this.handlePlugwrapCancel}>
                    <PlugwrapThickness 
                        updatePlugwrapValue={this.updatePlugwrapValue}
                        handlePlugwrapCancel={this.handlePlugwrapCancel}
						rowSelectionDisable={true}>
                    </PlugwrapThickness>
                </Modal>
            </div>
        )
    }
}

export default TowItemPlugwrap;


// WEBPACK FOOTER //
// ./src/containers/TowItemPlugwrap/index.js